module.exports = __webpack_public_path__ + "img/top.78f9e670.svg";